module.exports = "<div class=\"search-popup-container\" *ngIf=\"!isLoading\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <lfwms-search-filter [searchService]=\"searchService\">\r\n      </lfwms-search-filter>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/search-filter-popup/search-filter-popup.component.html
// module id = ../../../../../src/app/shared/lookup/search-filter-popup/search-filter-popup.component.html
// module chunks = main